import UserAddController from './user.add.controller';

export default {
    controller: UserAddController,
    template: require('./user.add.tpl.html')
};
